import { useIntl } from '@topwrite/common';


export function StartScreen() {

    const intl = useIntl();

    return <div className='DocSearch-StartScreen'>
        <p className='DocSearch-Help'>{intl.$t({ defaultMessage: '我是一个智能AI助理，你可以向我提问关于本文档的任何问题' })}</p>
    </div>;
}
